<template>

  <v-container fluid class="pt-4 pb-8 order-summary" v-if="order">

    <v-row class="pa-0 ma-0">
      <!------------------->
      <!-- Order Details -->
      <!------------------->
      <!-- class="pb-4 pl-6 pr-4 mb-4" -->
      <v-col cols="12" xs="12" sm="12" md="6" lg="6">
        <!-- Title: Order Details -->
        <v-row>
          <v-col cols="12">
            <span class="title">Order Details</span>
          </v-col>
        </v-row>

        <!-- Provider Order Info & Shipper -->
        <v-row class="mt-5">
          <v-col cols="5" xs="5" sm="3" md="3" lg="2">
            <span class="attr-label">Provider:</span>
          </v-col>
          <v-col cols="7" xs="7" sm="9" md="9" lg="10">
            <span>{{ providerName }}</span>
          </v-col>
        </v-row>
        <v-row class="mt-2">
          <v-col cols="12" xs="12" sm="3" md="3" lg="2">
            <span class="attr-label">Shipper:</span>
          </v-col>
          <v-col cols="12" xs="12" sm="9" md="9" lg="10">
            <span>{{ shipperName }}</span>
          </v-col>
        </v-row>
        <v-row class="mt-2" v-if="brandName">
          <v-col cols="12" xs="12" sm="3" md="3" lg="2">
            <span class="attr-label">Brand:</span>
          </v-col>
          <v-col cols="12" xs="12" sm="9" md="9" lg="10">
            <span>{{ brandName }}</span>
          </v-col>
        </v-row>

        <!-- Provider Order Invoice (link) -->
        <v-row class="mt-2 mb-2" v-if="providerInvoiceUrl && uiType === 'shipper'">
          <v-col cols="12" xs="12" sm="3" md="3" lg="2">
            <span class="attr-label">Invoice:</span>
          </v-col>
          <v-col cols="12" xs="12" sm="9" md="9" lg="10">
            <a :href="providerInvoiceUrl" :title="providerInvoiceUrl" target="_new">{{ providerName }} Invoice</a>
            <v-icon class="ml-2" style="font-size:16px" color="primary">mdi-open-in-new</v-icon>
          </v-col>
        </v-row>

        <!-- Order Tracking Number -->
        <v-row class="mt-4" v-if="order.tracking_number">
          <v-col cols="12" xs="12" sm="3" md="3" lg="2" class="d-flex align-center">
            <span class="attr-label">Tracking#</span>
          </v-col>
          <v-col cols="12" xs="12" sm="9" md="9" lg="10" class="d-flex align-center">
            <span style="font-size:1.1em">{{ formatTrackingNumber }}</span>
            <v-btn plain color="primary" @click="$root.copyToClipboard(order.tracking_number)">
              <v-icon class="icon-copy">mdi-content-copy</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <!-- Order Total -->
        <v-row class="mt-3 mb-2 d-flex align-center">
          <v-col cols="5" xs="5" sm="3" md="3" lg="2">
            <span class="attr-label">Total:</span>
          </v-col>
          <v-col cols="7" xs="7" sm="9" md="9" lg="10">
            <span class="order-total">{{ orderTotal }}</span>
          </v-col>
        </v-row>
      </v-col>

      <!------------------------------------------------------------->
      <!-- Provider Order Compare and Cancel Action (for shippers) -->
      <!-- (For status: PLACED)                                    -->
      <!------------------------------------------------------------->
      <template v-if="uiType === 'shipper' && order.order_status === 'PLACED'">
        <!-- TODO - Nothing now -->
      </template>

      <!------------------------------>
      <!-- Order Status Info        -->
      <!-- (For all other statuses) -->
      <!------------------------------>
      <v-col cols="12" xs="12" sm="12" md="6" lg="6" align="left" v-else-if="order.order_status !== 'PLACED' && order.order_status !== 'BEING_SCHEDULED'">
        <!-- Title: Status Updates -->
        <v-row>
          <v-col cols="12" class="d-flex align-center">
            <!-- <v-icon color="yellow darken-2" style="font-size:22px;" class="mr-2">mdi-alarm-check</v-icon> -->
            <span class="title">Status Updates</span>
          </v-col>
        </v-row>

        <!-- Delivery flow statuses -->
        <div class="mt-7 d-flex align-start" v-if="statusDetailOneHeader">
          <div style="width:140px;" class="attr-label">{{ statusDetailOneHeader }}:</div>
          <div>
            <div class="status-detail-date">{{ statusDetailOneDate }}</div>
            <div class="status-detail-time mt-1">{{ statusDetailOneTime }}</div>
          </div>
        </div>
        <div class="mt-8 d-flex align-start" v-if="statusDetailTwoHeader">
          <div style="width:140px;" class="attr-label">{{ statusDetailTwoHeader }}:</div>
          <div>
            <div class="status-detail-date">{{ statusDetailTwoDate }}</div>
            <div class="status-detail-time mt-1">{{ statusDetailTwoTime }}</div>
          </div>
        </div>

        <!-- Being rescheduled message -->
        <div class="mt-8 grey--text" style="font-size:1.1rem;" v-if="isBeingRescheduled">
          (Order is being rescheduled)
        </div>

        <!-- Rejected reason -->
        <div class="mt-8" v-if="isRejected">
          <div class="attr-label">Reason:</div>
          <div class="mt-2" v-if="order.shipper_notes">{{ order.shipper_notes }} </div>
          <div class="mt-2" v-else>{{ order.receiver_notes }} </div>
        </div>

        <!-- Payment info (for delivered status) -->
        <div class="mt-8 d-flex align-start" v-if="isDelivered && !isCredit">
          <div style="width:140px;" class="attr-label">Payment:</div>
          <div>
            <div class="payment-text">{{ paymentReceivedTextToDisplay }}</div>
            <div v-if="paymentTypeTextToDisplay"><span class="grey--text mr-2">type:</span>{{ paymentTypeTextToDisplay }}</div>
          </div>
        </div>
      </v-col>
    </v-row>

  </v-container>

</template>

<script>
export default {
  name: 'OrderSummary',

  props: {
    order: {
      type: Object,
      default: null
    },
    showSubmitter: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      isOrderUpdating: false,
      orderUpdatingError: null,
      providerCompareResults: null
    }
  },

  computed: {
    uiType () {
      return this.$root.uiType()
    },
    activeOrg () {
      return this.$store.getters['auth/activeOrg']
    },
    orderNumberForDisplay () {
      return this.order.thirdparty_order_number
    },
    formatTrackingNumber () {
      const data = (this.order.tracking_number) ? this.order.tracking_number.match(/.{1,4}/g) : null
      return (data) ? data.join(' ') : null
    },
    orderTotal () {
      const totalAsNum = this.order?.order_details?.total || 0
      return `$${Number(totalAsNum).toLocaleString(undefined, { minimumFractionDigits: 2 })}`
    },
    // ------------------------------------------- Status Info
    isCredit () {
      return this.order.order_status === 'DELIVERED' && !this.order.route_id
    },
    isBeingRescheduled () {
      return this.order.order_status === 'RESCHEDULED'
    },
    isDelivered () {
      return this.order.delivered_at
    },
    isRejected () {
      return this.order.rejected_at
    },
    isCanceled () {
      return this.order.canceled_at
    },
    formatPlacedDate () {
      return (this.order.placed_at)
        ? this.$root.utils.format(this.order.placed_at, 'dddd MMM Do, YYYY (z)')
        : ''
    },
    statusDetailOneHeader () {
      if (this.order.order_status === 'SCHEDULED') return 'Est. Pickup'
      if (this.order.order_status === 'TO_SHIPPER') return 'To Shipper'
      if (this.order.order_status === 'AT_SHIPPER') return 'At Shipper'
      if (this.order.order_status === 'PICKED_UP') return 'Picked-up'
      if (this.order.order_status === 'TO_RECEIVER') return 'To Receiver'
      if (this.order.order_status === 'AT_RECEIVER') return 'At Receiver'
      if (this.isDelivered) return (this.isCredit) ? 'Issued' : 'Delivered'
      if (this.isRejected) return 'Rejected'
      if (this.isCanceled) return 'Canceled'
      return null
    },
    statusDetailOneDate () {
      if (this.order.order_status === 'SCHEDULED') return this.formatDate(this.order.estimated_shipper_arrival_time)
      if (this.order.order_status === 'TO_SHIPPER') return this.formatDate(this.order.to_shipper_at)
      if (this.order.order_status === 'AT_SHIPPER') return this.formatDate(this.order.at_shipper_at)
      if (this.order.order_status === 'PICKED_UP') return this.formatDate(this.order.picked_up_at)
      if (this.order.order_status === 'TO_RECEIVER') return this.formatDate(this.order.to_receiver_at)
      if (this.order.order_status === 'AT_RECEIVER') return this.formatDate(this.order.at_receiver_at)
      if (this.isDelivered) return this.formatDate(this.order.delivered_at)
      if (this.isRejected) return this.formatDate(this.order.rejected_at)
      if (this.isCanceled) return this.formatDate(this.order.canceled_at)
      return ''
    },
    statusDetailOneTime () {
      if (this.order.order_status === 'SCHEDULED') return this.formatTime(this.order.estimated_shipper_arrival_time)
      if (this.order.order_status === 'TO_SHIPPER') return this.formatTime(this.order.to_shipper_at)
      if (this.order.order_status === 'AT_SHIPPER') return this.formatTime(this.order.at_shipper_at)
      if (this.order.order_status === 'PICKED_UP') return this.formatTime(this.order.picked_up_at)
      if (this.order.order_status === 'TO_RECEIVER') return this.formatTime(this.order.to_receiver_at)
      if (this.order.order_status === 'AT_RECEIVER') return this.formatTime(this.order.at_receiver_at)
      if (this.isDelivered) return this.formatTime(this.order.delivered_at)
      if (this.isRejected) return this.formatTime(this.order.rejected_at)
      if (this.isCanceled) return this.formatTime(this.order.canceled_at)
      return ''
    },
    statusDetailTwoHeader () {
      if (
        this.order.order_status === 'SCHEDULED' ||
        this.order.order_status === 'TO_SHIPPER' ||
        this.order.order_status === 'AT_SHIPPER' ||
        this.order.order_status === 'PICKED_UP' ||
        this.order.order_status === 'TO_RECEIVER'
      ) return 'Est. Delivery'
      return null
    },
    statusDetailTwoDate () {
      if (
        this.order.order_status === 'SCHEDULED' ||
        this.order.order_status === 'TO_SHIPPER' ||
        this.order.order_status === 'AT_SHIPPER' ||
        this.order.order_status === 'PICKED_UP' ||
        this.order.order_status === 'TO_RECEIVER'
      ) return this.formatDate(this.order.estimated_receiver_arrival_time)
      return null
    },
    statusDetailTwoTime () {
      if (
        this.order.order_status === 'SCHEDULED' ||
        this.order.order_status === 'TO_SHIPPER' ||
        this.order.order_status === 'AT_SHIPPER' ||
        this.order.order_status === 'PICKED_UP' ||
        this.order.order_status === 'TO_RECEIVER'
      ) return this.formatTime(this.order.estimated_receiver_arrival_time)
      return null
    },
    // ------------------------------------------- Shipper Info
    shipperName () {
      return this.order?.shipper?.name || ''
    },
    // ------------------------------------------- Submitter Info
    submitter () {
      return this.order.submitter || {}
    },
    submitterName () {
      const firstName = this.submitter.first_name
      const lastName = this.submitter.last_name
      return (lastName) ? `${firstName} ${lastName}` : firstName
    },
    // ------------------------------------------- Provider Info
    activeAccountInfo () {
      // We just need the account alias, which is the account name in kebab-case form
      return {
        account: { alias: this.$root.utils.toKebabCase(this.accountName) }
      }
    },
    providerInvoiceUrl () {
      return this.$root.providerInvoiceUrl(this.order, this.activeAccountInfo)
    },
    providerName () {
      return (this.order.provider_alias)
        ? this.$root.providerAliasToName(this.order.provider_alias)
        : ''
    },
    accountName () {
      return this.order.thirdparty_account_name
    },
    brandName () {
      return this.order.thirdparty_brand_name
    },
    // ------------------------------------------- Payment Info
    paymentReceived () {
      return this.order.delivery_info?.paid_on_delivery
    },
    paymentType () {
      return this.order.delivery_info?.payment_type
    },
    paymentReceivedTextToDisplay () {
      return (this.paymentReceived)
        ? 'Payment received on delivery'
        : 'No payment received'
    },
    paymentTypeTextToDisplay () {
      switch (this.paymentType) {
        case 'ach': return 'ACH'
        case 'cash': return 'Cash'
        case 'check': return 'Check'
        default: return null
      }
    }
  },

  methods: {
    formatDate (date) {
      return (date)
        ? this.$root.utils.format(date, 'dddd MMM D, YYYY')
        : ''
    },

    formatTime (date) {
      return (date)
        ? this.$root.utils.dateFormat(date, 'h:mm a z')
        : ''
    }
  }
}
</script>

<style scoped>
  .order-summary .status-detail-date {
    font-size: 1.1rem;
    font-weight: 400;
  }

  .order-summary .status-detail-time {
    font-size: 1.1rem;
    font-weight: 500;
  }

  .order-summary .order-total {
    font-size: 1.36rem;
    font-weight: 400;
  }

  .order-summary .payment-text {
    font-size: 1.0rem;
    font-weight: 400;
  }

  .order-summary a {
    text-decoration: none;
  }
  .order-summary a:hover {
    text-decoration: underline;
  }

  @media screen and (max-width: 600px) {
    .order-summary-title {
      font-size: 1.5em;
    }
  }
</style>
